// extracted by mini-css-extract-plugin
module.exports = {"documentDetailCont":"DocumentDetail_documentDetailCont__-ZDFE","close":"DocumentDetail_close__3ToA7"};